import React, { useState } from "react";
import { useNotification } from "../../../../Notifications/NotificationProvider";
import { InventoryService } from "../../../network/InventoryService";
import FileUpload from "../../Common/FileUpload";

const UnbindingRequestBulkUploader = ({
  setShowUnbindingRequestModal,
  onUnbindingRequestCreated,
}) => {
  const [uploadedFile, setUploadedFile] = useState(null);
  const [isDownloading, setIsDownloading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const dispatchNotification = useNotification();

  const mappingFields = ["Merchant Wallet", "Counter"];

  const handleFileUpload = async (event) => {
    const file = event.target.files[0];
    if (file) {
      const allowedTypes = [
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "application/vnd.ms-excel",
        "text/csv",
      ];

      if (allowedTypes.includes(file.type) || file.name.endsWith(".csv")) {
        setUploadedFile(file);
      } else {
        dispatchNotification({
          type: "ERROR",
          message: "Please upload only Excel (.xlsx, .xls) or CSV files.",
        });
      }
    }
    event.target.value = "";
  };

  const handleDownloadSample = async () => {
    setIsDownloading(true);
    try {
      const endpoint = `${process.env.REACT_APP_API_URL}/api/payment_speaker/upload/approve-unbind-request`;
      await InventoryService.downloadSampleFile(
        endpoint,
        "approve-unbind-request-sample.xlsx"
      );

      dispatchNotification({
        type: "SUCCESS",
        message: "Sample file downloaded successfully!",
      });
    } catch (error) {
      console.error("Error downloading sample file:", error);
      dispatchNotification({
        type: "ERROR",
        message: "Failed to download sample file. Please try again.",
      });
    } finally {
      setIsDownloading(false);
    }
  };

  const handleSubmit = async () => {
    if (!uploadedFile) {
      dispatchNotification({
        type: "ERROR",
        message: "Please upload a mapping file first.",
      });
      return;
    }

    setIsSubmitting(true);

    try {
      const response =
        await InventoryService.uploadUnbindingRequest(uploadedFile);

      if (response.is_error === 0) {
        dispatchNotification({
          type: "SUCCESS",
          message: "Unbinding request uploaded successfully!",
        });

        setUploadedFile(null);
        setShowUnbindingRequestModal(false);
        if (onUnbindingRequestCreated) {
          onUnbindingRequestCreated();
        }
      } else if (response.is_error === 1) {
        throw new Error(response.message || "Failed to upload rollout mapping");
      }
    } catch (error) {
      console.error("Error uploading rollout mapping:", error);

      let errorMessage = "Failed to upload rollout mapping. Please try again.";
      if (error.response?.data?.message) {
        errorMessage = error.response.data.message;
      }

      dispatchNotification({
        type: "ERROR",
        message: errorMessage,
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div
      className="inventory-modal-overlay"
      onClick={() =>
        !isSubmitting && !isDownloading && setShowUnbindingRequestModal(false)
      }
    >
      <div
        className="inventory-modal rollout-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="inventory-modal-header">
          <h3>Upload Unbinding Request</h3>
          <button
            className="close-btn"
            type="button"
            onClick={() =>
              !isSubmitting &&
              !isDownloading &&
              setShowUnbindingRequestModal(false)
            }
            disabled={isSubmitting || isDownloading}
          >
            ×
          </button>
        </div>
        <div className="inventory-modal-body">
          <div className="upload-mapping-area">
            <FileUpload
              uploadedFile={uploadedFile}
              setUploadedFile={setUploadedFile}
              handleFileUpload={handleFileUpload}
              handleDownloadSample={handleDownloadSample}
              isUploading={false}
              isDownloading={isDownloading}
              isDisabled={isSubmitting || isDownloading}
              uploadTitle="Upload Mapping File"
              uploadSubtitle=""
              showMappingLayout={true}
              mappingFields={mappingFields}
              mappingNote="(A counter can only be unbinded if an unbinding request has been placed against it for that merchant wallet)"
              fileInputId="mapping-file"
            />
          </div>
        </div>
        <div className="inventory-modal-footer">
          <button
            className="cancel-btn"
            type="button"
            onClick={() =>
              !isSubmitting &&
              !isDownloading &&
              setShowUnbindingRequestModal(false)
            }
            disabled={isSubmitting || isDownloading}
          >
            Cancel
          </button>
          <button
            className="submit-btn"
            type="button"
            onClick={handleSubmit}
            disabled={isSubmitting || isDownloading || !uploadedFile}
          >
            {isSubmitting ? "Uploading..." : "Upload Mapping"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default UnbindingRequestBulkUploader;
